<template>
  <div class="inline-form">
    <div v-if="errors.length > 0" class="error-messages">
      <p class="message-error ss-alert">{{ errors.join(', ') }}</p>
    </div>

    <form v-if="showingForm">
      <slot name="fields"></slot>
      <input @click.prevent="saveForm" type="submit" class="cm-button small" :value="I18n.t('save')" />
    </form>

    <div v-else class="inline-form__content">
      <slot></slot>
      <button v-if="editable" @click="showForm" class="edit-button ss-icon">compose</button>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['company', 'editable'],
    data: function () {
      return {
        showingForm: false,
        errors: []
      }
    },
    methods: {
      showForm() {
        this.showingForm = true
      },
      saveForm() {
        this.errors = []

        this.$http.patch('/companies/' + this.company.id, { company: this.company }).then(response => {
          // TODO Emit updated data to parent?
          this.showingForm = false
        }, response => {
          this.errors = response.body.errors
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../components/edit-button';

  .inline-form {
    margin-bottom: $gutter / 4;
  }

  .cm-field {
    margin-bottom: 10px;
  }

  .inline-form__content {
    display: flex;
    flex-direction: row;
    align-items: top;
  }

  .error-messages {
    margin-bottom: $gutter / 4;
  }

  .message-error:before {
    margin-right: 3px;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// app/javascript/company/inline-form.vue?069175d3